import { OfferProps, PaymentMethods } from '../contexts/OneClickBuyContext/types';
import { isApplePay } from './paymentMethod';

const OFFER_PAYMENT_FLAGS: Array<[PaymentMethods, keyof OfferProps]> = [
	[PaymentMethods.CARD, 'allow_credit_card'],
	[PaymentMethods.PIX, 'allow_pix'],
	[PaymentMethods.BANK_SLIP, 'allow_bank_slip'],
];

export const getAllowedPaymentMethods = (offer?: Partial<OfferProps> | null): PaymentMethods[] =>
	OFFER_PAYMENT_FLAGS.filter(([, flag]) => Boolean(offer?.[flag])).map(([method]) => method);

export const getHighlightedPaymentMethod = (
	previousMethod: PaymentMethods | null | undefined,
	allowedMethods: PaymentMethods[]
): PaymentMethods | null => {
	if (!previousMethod) return null;

	const offerMethod = isApplePay(previousMethod) ? PaymentMethods.CARD : previousMethod;

	return allowedMethods.includes(offerMethod) ? previousMethod : null;
};

export const getPaymentMethodOptions = (
	allowedMethods: PaymentMethods[],
	highlightedMethod: PaymentMethods | null
): PaymentMethods[] =>
	highlightedMethod && !allowedMethods.includes(highlightedMethod)
		? [highlightedMethod, ...allowedMethods]
		: allowedMethods;
